// extracted by mini-css-extract-plugin
export default {"HomeButton":"ButtonHome_HomeButton__NMtdx","HomeImg":"ButtonHome_HomeImg__RBWDS"};